import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

export const useFirstPromoter = (enabled: boolean = true) => {
  const [params] = useSearchParams()

  useEffect(() => {
    if (!enabled) return

    const fpr = params.get("fpr")
    if (!fpr) return

    localStorage.setItem("client_reference_id", fpr)
  }, [enabled, params])
}
